export default "__VITE_ASSET__a6cb0785__$_?inline__"